import { render, staticRenderFns } from "./SushiDiaoxianItem.vue?vue&type=template&id=2921f449&scoped=true&"
import script from "./SushiDiaoxianItem.vue?vue&type=script&lang=js&"
export * from "./SushiDiaoxianItem.vue?vue&type=script&lang=js&"
import style0 from "./SushiDiaoxianItem.vue?vue&type=style&index=0&id=2921f449&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2921f449",
  null
  
)

export default component.exports